import { extendTheme } from "@chakra-ui/react";

const theme = extendTheme({
  colors: {
    // Forest - Authority (Nature's Pulse core foundation)
    forest: {
      50: '#E8F5E9',
      100: '#D8F3DC',
      200: '#B7E4C7',
      300: '#74C69D',
      400: '#52B788',
      500: '#40916C',
      600: '#2D6A4F',
      700: '#1B4332',
      800: '#081C15',
      900: '#040E0A',
    },
    // Harvest - Emphasis & Living Action (Orange/Amber equity refined)
    harvest: {
      50: '#FFFBEB',
      100: '#FEF3C7',
      200: '#FDE68A',
      300: '#FCD34D',
      400: '#FBBF24',
      500: '#F59E0B',
      600: '#D97706',
      700: '#B45309',
      800: '#92400E',
      900: '#78350F',
    },
    // Warm Neutrals - Soil, Canvas & Tactile Surfaces
    warm: {
      50: '#FCFAF6',
      100: '#F8F4ED',
      200: '#F0E8DC',
      300: '#E3D7C5',
      400: '#D1BEA5',
      500: '#B89F82',
      600: '#957C60',
      700: '#735D45',
      800: '#554330',
      900: '#3A2C1F',
    },
    // Semantic Surface & Ink Tokens
    surface: {
      canvas: '#FBF9F5',
      card: '#FFFFFF',
      cardMuted: '#F5F1EB',
      border: '#E7DFD5',
      borderSubtle: '#EFEAE2',
    },
    ink: {
      primary: '#151916',
      secondary: '#48534C',
      tertiary: '#7A867E',
      inverse: '#FFFFFF',
    },
    // Backward-compatible Brand Aliases
    brand: {
      green: "#1B4332",
      brown: "#735D45",
      orange: "#D97706",
      greenPalette: {
        500: "#2D6A4F",
      },
    },
  },
  fonts: {
    heading: "'Plus Jakarta Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
    body: "'Plus Jakarta Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
    serif: "'Newsreader', Georgia, serif",
  },
  styles: {
    global: {
      'html, body': {
        bg: '#FBF9F5',
        color: '#151916',
        letterSpacing: '-0.01em',
        WebkitTapHighlightColor: 'transparent',
      },
      '::selection': {
        bg: '#D8F3DC',
        color: '#081C15',
      },
    },
  },
  components: {
    Button: {
      baseStyle: {
        fontWeight: '600',
        borderRadius: 'xl',
        transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
        _focusVisible: {
          boxShadow: '0 0 0 3px rgba(27, 67, 50, 0.25)',
        },
      },
      sizes: {
        md: {
          h: '44px',
          minH: '44px',
          px: '18px',
          fontSize: 'sm',
        },
        lg: {
          h: '48px',
          minH: '48px',
          px: '24px',
          fontSize: 'md',
        },
        xl: {
          h: '56px',
          fontSize: 'lg',
          px: '32px',
        },
      },
      variants: {
        forest: {
          bg: 'forest.700',
          color: 'white',
          _hover: {
            bg: 'forest.800',
            _disabled: { bg: 'forest.700' },
          },
          _active: {
            bg: 'forest.900',
          },
        },
        harvest: {
          bg: 'harvest.600',
          color: 'white',
          _hover: {
            bg: 'harvest.700',
            _disabled: { bg: 'harvest.600' },
          },
          _active: {
            bg: 'harvest.800',
          },
        },
        'outline-warm': {
          bg: 'white',
          border: '1px solid',
          borderColor: 'surface.border',
          color: 'ink.primary',
          _hover: {
            bg: 'warm.50',
            borderColor: 'forest.600',
          },
        },
        'with-shadow': {
          bg: 'forest.700',
          color: 'white',
          boxShadow: '0 4px 14px rgba(27, 67, 50, 0.2)',
        },
        sm: {
          bg: 'forest.600',
          color: 'white',
        },
      },
    },
    Card: {
      baseStyle: {
        container: {
          bg: 'surface.card',
          borderRadius: '2xl',
          border: '1px solid',
          borderColor: 'surface.border',
          boxShadow: '0 1px 3px rgba(0,0,0,0.02), 0 4px 12px rgba(27,67,50,0.03)',
        },
      },
    },
  },
});

export default theme;